module.exports = __webpack_public_path__ + "img/202509-2_06.54827a04.jpg";